// External Dependencies:
import React from 'react'

// Internal Dependencies:
import LoadScript from 'containers/LoadScript'

class Password extends React.Component {
	constructor( props ) {
		super( props )

		this.state = {
			value: props.value,
			hasError: false,
			passwordScore: ''
		}
	}

	static defaultProps = {
		label: false,
		handleError: false,
		focus: false,
		allowBlank: false
	}

	componentDidMount() {
		if ( this.props.focus ) {
			this.input.focus()
		}
	}

	componentDidUpdate( prevProps, prevState ) {
		if ( this.props.focus ) {
			this.input.focus()
		}
	}

	handleChange = ( e ) => {
		this.setState( {
			value: e.target.value
		})

		this.getPasswordStrength( e.target.value )

		this.props.onChange( this.props.id, e.target.value )
	}

	handleError = ( e ) => {
		this.props.handleError( this.props.id, hasError )
	}

	getPasswordStrength = ( pass ) => {
		const { allowBlank } = this.props
		const strength = {
		  0: 'Poor',
		  1: 'Poor',
		  2: 'Weak',
		  3: 'Good',
		  4: 'Strong'
		}

		let score = 0
		let scoreWord = ''
		let valid = true
		let hasError

		if ( typeof zxcvbn === 'function' ) {
			let result = zxcvbn( pass )

			score = result.score
			valid = score > 2 ? true : false
			scoreWord = strength[ score ]
		}

		hasError = ! valid

		if ( ! pass && allowBlank ) {
			hasError = false
		}

		this.setState( {
			passwordScore: scoreWord,
			hasError: hasError
		})

		if ( this.props.handleError ) {
			this.props.handleError( this.props.id, hasError )
		}
	}

	render() {
		const { id, label, value, allowBlank } = this.props
		const { hasError, passwordScore } = this.state
		let className = hasError ? 'form-item form-password has-error' : 'form-item form-password'
		className += ` is-${passwordScore}`
		let showNote = true

		if ( allowBlank && ! this.state.value ) {
			showNote = false
		}

		return (
			<div className={ className }>
				<LoadScript src="https://cdnjs.cloudflare.com/ajax/libs/zxcvbn/4.2.0/zxcvbn.js" />

				{ label &&
					<label htmlFor={ id } dangerouslySetInnerHTML={ { __html: label } } />
				}

				<input type="password" name={ id } value={ this.state.value } onChange={ this.handleChange } ref={ e => this.input = e } />

				{ showNote &&
					<div className="form-note">
						{ passwordScore }
					</div>
				}
			</div>
		)
	}
}

export default Password
